import React from 'react';
import '../styles/givingBadge.css';

const GivingBadge = ({ children, label, variant = 'gray', dot = false, style }) => (
  <span className={`gc-badge gc-badge--${variant}${dot ? ' gc-badge--with-dot' : ''}`} style={style}>
    {dot && <span className="gc-badge-dot" aria-hidden="true" />}
    {children || label}
  </span>
);

export default GivingBadge;
